<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label mr-2" :for="id">{{ label }}:</label>
    <input :id="id" ref="input" :disabled="disabled" v-bind="{ ...$attrs, class: null }" class="form-input" :class="{ error: error }" type="date" :value="modelValue" :min="min" @input="handleDateInput" />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `date-picker-${uuid()}`
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: String,
    label: String,
    modelValue: String,
    min: String,
    validator: {
      type: Function,
      default: () => true,
    },
  },

  emits: ['update:modelValue'],

  methods: {
    handleDateInput(event) {
      const selectedDate = event.target.value
      const date = new Date(selectedDate)
      const day = date.getDay()

      // Check if it's a weekend (0 = Sunday, 6 = Saturday)
      if (day === 0 || day === 6) {
        event.target.value = this.modelValue // Reset to previous value
        alert('Please select a weekday (Monday to Friday)')
        return
      }

      // If validator is provided, use it
      if (this.validator && !this.validator(selectedDate)) {
        event.target.value = this.modelValue
        return
      }

      this.$emit('update:modelValue', selectedDate)
    },

    focus() {
      this.$refs.input.focus()
    },

    select() {
      this.$refs.input.select()
    },

    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>

<style scoped>
input[type='date'] {
  position: relative;
}

/* Style the calendar icon */
input[type='date']::-webkit-calendar-picker-indicator {
  cursor: pointer;
}

/* Disable weekend dates visually (works in some browsers) */
input[type='date']:invalid {
  color: #999;
}
</style>
